var render = function render(){var _vm=this,_c=_vm._self._c;return _c('material-stats-card',{attrs:{"color":_vm.color,"icon":"mdi-hanger","title":_vm.titleComponent,"value":_vm.data,"sub-icon":"mdi-tag","sub-text":"Tracked from Database"}})
}
var staticRenderFns = []

export { render, staticRenderFns }